import { render, staticRenderFns } from "./DocumentOverdue.vue?vue&type=template&id=ac7ffd02"
import script from "./DocumentOverdue.vue?vue&type=script&lang=js"
export * from "./DocumentOverdue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports